/**
 * Datos de noticias del Colegio Bertolt Brecht
 * Array de noticias que se puede ir actualizando
 */

export const NEWS_DATA = [
    {
        id: 1,
        title: 'Clases en Línea: Accede a tu Sala Virtual',
        slug: 'clases-en-linea-salas-virtuales',
        date: '2026-03-22',
        category: 'Comunicado',
        excerpt: 'Ya están disponibles las salas virtuales de Google Meet para todos los grados de Primaria y Secundaria. Ingresa fácilmente desde nuestra sección de Salas.',
        content: `Estimada comunidad educativa:

Nos complace informarles que las salas virtuales de Google Meet para las clases en línea están disponibles para todos los grados y secciones del colegio.

Primaria (1° al 6°) y Secundaria (1° al 5°) cuentan con su sala virtual asignada, a la que pueden acceder en todo momento desde la sección "Salas" del portal.

Acceder es muy sencillo:
- Ingresa al menú principal y selecciona "Salas"
- Elige tu nivel (Primaria o Secundaria)
- Haz clic en el botón de tu grado para unirte a la reunión

Recomendamos acceder con anticipación y tener activada la cámara y el micrófono antes del inicio de la clase.

Para consultas o soporte técnico, comunícate con el área de sistemas.

Atentamente,
La Dirección`,
        image: '/assets/images/clases-linea.jpg',
        imageAlt: 'Clases en Línea',
        author: 'Dirección General',
        featured: true,
        enlace: '/salas',
    },
];

/**
 * Obtener noticias destacadas
 */
export const getFeaturedNews = () => {
    return NEWS_DATA.filter(news => news.featured);
};

/**
 * Obtener últimas noticias
 * @param {number} limit - Número de noticias a obtener
 */
export const getLatestNews = (limit = 3) => {
    return NEWS_DATA.slice(0, limit);
};

/**
 * Obtener noticia por slug
 * @param {string} slug - Slug de la noticia
 */
export const getNewsBySlug = (slug) => {
    return NEWS_DATA.find(news => news.slug === slug);
};

/**
 * Obtener noticias por categoría
 * @param {string} category - Categoría de la noticia
 */
export const getNewsByCategory = (category) => {
    return NEWS_DATA.filter(news => news.category === category);
};

/**
 * Formatear fecha
 * @param {string} dateString - Fecha en formato YYYY-MM-DD
 */
export const formatNewsDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0].replace(/-/g, '/');
};
